<dx-data-grid [dataSource]="requests$ | async">
	<dxo-pager [showPageSizeSelector]="false"></dxo-pager>

	<dxo-search-panel [visible]="false"></dxo-search-panel>

	<dxo-export [enabled]="false"></dxo-export>

	<dxo-column-chooser [enabled]="false"></dxo-column-chooser>

	<dxi-column dataField="companyName" caption="Company" dataType="string"></dxi-column>
	<dxi-column dataField="requesterName" caption="Requester" dataType="string"></dxi-column>
	<dxi-column dataField="requesterEmail" caption="Email Address" dataType="string"></dxi-column>
	<dxi-column caption="Actions" width="125px" cellTemplate="actionsCellTemplate"></dxi-column>

	<div class="actions-cell" *dxTemplate="let d of 'actionsCellTemplate'">
		<button class="btn btn-sm btn-primary" (click)="handleRequest(d.data.requestId, true)">Grant</button>
		<button class="btn btn-sm btn-danger" (click)="handleRequest(d.data.requestId, false)">Deny</button>
	</div>
</dx-data-grid>
